import { NAMESPACE as AUTHENTICATION_NAMESPACE, STATE as AUTHENTICATION_STATE } from "@/constants/vuex/authentication";

export const getAutofillValue = (variable, store) => {
  switch (variable) {
    case "group_name":
      return store.state[AUTHENTICATION_NAMESPACE][AUTHENTICATION_STATE.S_GROUP_NAME]

    case "user_name":
      return this.$store.state[AUTHENTICATION_NAMESPACE][AUTHENTICATION_STATE.S_NAME]

    case "user_email":
      return store.state[AUTHENTICATION_NAMESPACE][AUTHENTICATION_STATE.S_USERNAME]

    case "group_contact_email":
      return store.state[AUTHENTICATION_NAMESPACE][AUTHENTICATION_STATE.S_GROUP_CONTACT_EMAIL]

    default:
      return variable
  }
}